/* global axios */
// WA-02: os números próprios da Powerbizz, na autenticação do app.
// Usa o axios global pelo mesmo motivo do `powerAgents.js`: ele carrega os headers de sessão
// do DeviseTokenAuth, e um fetch() cru devolveria 401.
//
// Existe porque a tela da WA-01 vive no Administrate, sob `devise_for :super_admins` — outro
// escopo de login. Clicar nela a partir do app redirecionava para um segundo sign-in.

const BASE = accountId =>
  `/api/v1/accounts/${accountId}/whatsapp/owned_numbers`;

const body = r => r.data;

export default {
  // { numbers: [...], errors: { <waba_id>: motivo } }
  list(accountId) {
    return axios.get(BASE(accountId)).then(body);
  },

  // Cria a inbox na conta da URL e devolve { id, name }. O vínculo com o agente é um passo
  // separado, feito por quem chama — é o mesmo caminho do Embedded Signup.
  connect(accountId, { wabaId, phoneNumberId, phoneNumber, inboxName }) {
    return axios
      .post(BASE(accountId), {
        waba_id: wabaId,
        phone_number_id: phoneNumberId,
        phone_number: phoneNumber,
        inbox_name: inboxName,
      })
      .then(body);
  },
};
